import React, { useContext } from "react";
import styles from "./IndicatorLabel.module.css";
import { FaRegCalendarTimes } from "react-icons/fa";
import indicatorImg from "../../assets/images/chemical.jpg";
import { getImageIndicatorByName } from "../../utils/indicatorImage";
import df from "../../utils/dateFormater";
import t from "../../utils/translation";

export default function IndicatorLabel({
  name,
  lot,
  expirationDate,
  serial,
  quantity,
  zone,
  load,
  backgroundColor,
  border,
  animation,
  status,
  nro,
  readingBiId,
  result = null,
  evaluationResult = null,
  resultBiologic = null,
  pcd,
  resultCH = null,
  userResultCH = null,
  detail,
  category = "Sterilization",
  tubeResultPro,
  statusDescription
}) {
  const getColorForResult = (result) => {
    switch (result) {
      case 3:
        return "red";
      case 4:
        return "green";
      default:
        return "";
    }
  };

  const getColorForEvaluationResult = (evaluationResult) => {
    switch (evaluationResult) {
      case 1:
        return "red";
      case 0:
        return "green";
      default:
        return "";
    }
  };

  const getColorForResultBiologic = (result) => {
    switch (result) {
      case 1:
        return "red";
      case 2:
        return "green";
      case 3:
        return "black";
      default:
        return "";
    }
  };

  const getResultText = (result) => {
    switch (result) {
      case 3:
        return `${t("UnsafeSpan")} - `;
      case 4:
        return `${t("SafeSpan")} - `;
      default:
        return "";
    }
  };

  const getEvaluationText = (evaluationResult) => {
    switch (evaluationResult) {
      case 0:
        return t("AgreeSpan");
      case 1:
        return t("DisagreeSpan");
      default:
        return "";
    }
  };

  const getResultBiologic = (result) => {
    switch (result) {
      case 1:
        return t("PositiveSpan");
      case 2:
        return t("NegativeSpan");
      case 3:
        return t("CanceledSpan");
      default:
        return "";
    }
  };

  const getResultCH = (result) => {
    switch (result) {
      case 3:
        return `${t("UnsafeSpan")} - `;
      case 4:
        return `${t("SafeSpan")} - `;
      default:
        return "";
    }
  };

  const getColorForResultCH = (result) => {
    switch (result) {
      case 3:
        return "red";
      case 4:
        return "green";
      default:
        return "";
    }
  };

  const getUserResultCH = (result) => {
    switch (result) {
      case 0:
        return t("AgreeSpan");
      case 1 :
        return t("DisagreeSpan");
      default:
        return "";
    }
  };

  const getColorForUserResultCH = (result) => {
    switch (result) {
      case 0:
        return "green";
      case 1:
        return "red";
      default:
        return "";
    }
  };

  const getResultPro = (statusDescription, tubeResultPro) => {
    if (statusDescription === "IN PROGRESS") {
      return "In progress"; 
    }
  
    switch (tubeResultPro) {
      case 1:
        return "Negative";
      case 2:
        return "Cancelled";
      case 3:
        return "Positive";
      case 4:
        return "Negative without pencil";
      case 263:
        return "Pen not valid";
      case 770:
        return "Pen pulled out";
      case 10:
        return "Alert";
      case 11:
        return "Action";
      case 12:
        return "Associate area";
      default:
        return "";
    }
  };

  const getColorForResultPro = (statusDescription,tubeResultPro) => {
    if (statusDescription === "IN PROGRESS") {
      return "#FFC107"; 
    }
    switch (tubeResultPro) {
      case 0: // NO_RESULT
        return "#D6D6D6";
      case 1: // NEGATIVE
        return "green";
      case 2: // CANCELED
        return "#A0A0A0";
      case 3: // POSITIVE
        return "red";
      case 4: // NEGATIVE_WITHOUT_PENCIL
        return "#909090";
      case 263: // PEN_NOT_VALID
        return "#B0B0B0";
      case 770: // PEN_PULLED_OUT
        return "#808080";
      case 10: // ALERT
        return "#FFD40E";
      case 11: // TO_TAKE_ACTION
        return "#F50000";
      case 12: // ASSOCIATE_AREA
        return "#707070";
      default:
        return "";
    }
  };

  return (
    <div
      className={`${styles.labelContainer} ${styles[backgroundColor]} ${
        border ? styles.border : ""
      } ${animation ? styles.border : ""}`}
    >
      {
        <div className={styles.indicatorInfo}>
          <div>
            <p className={styles.indicatorName}>
              {name} {serial && ` - ${serial}`}
            </p>
            <div style={{display: "flex", gap: "2px"}}> 
            {(result) && (
              <p
                className={styles.result}
                style={{ color: getColorForResult(result) }}
              >
                {getResultText(result)}
              </p>
            )}
            {(evaluationResult) && (
              <p
                className={styles.result}
                style={{ color: getColorForEvaluationResult(evaluationResult) }}
              >
                {getEvaluationText(evaluationResult)}
              </p>
            )}
            {(!resultBiologic && readingBiId && name.toUpperCase().includes("BT")) && (
              <p
                className={styles.result}
                style={{ color: "var(--secondary-yellow)" }}
              >
                {t("InProgressSpan")}
              </p>
            )}
            {(resultBiologic) && (
              <p
                className={styles.result}
                style={{ color: getColorForResultBiologic(resultBiologic) }}
              >
                {getResultBiologic(resultBiologic)}
              </p>
            )}
            {(resultCH) && (
              <p
                className={styles.result}
                style={{ color: getColorForResultCH(resultCH) }}
              >
                {getResultCH(resultCH)}
              </p>
            )}
            {(userResultCH || userResultCH === 0) && (
              <p
                className={styles.result}
                style={{ color: getColorForUserResultCH(userResultCH) }}
              >
                {getUserResultCH(userResultCH)}
              </p>
            )}
              {(tubeResultPro || statusDescription) && (
              <p
                className={styles.result}
                style={{ color: getColorForResultPro(statusDescription,tubeResultPro) }}
              >
                {getResultPro(statusDescription,tubeResultPro)}
              </p>
            )}
            </div>
            {!zone && quantity && (
              <p className={styles.quantity}>
                {`${t("QuantitySpan")}: ${quantity}`}
              </p>
            )}
            {pcd && <p className={styles.quantity}>{`PCD: ${pcd}`}</p>}

            {zone && (
              <p className={styles.quantity}>
                {`${
                  category.toUpperCase() === "WASHING"
                    ? t("BlankEntry1")
                    : t("ZoneSpan")
                }: ${zone}`}
              </p>
            )}
          </div>
          <div className={styles.indicatorFooter}>
            <p>{lot}</p>
            <p>
              <FaRegCalendarTimes /> {df(expirationDate, "monthYear")}
            </p>
          </div>
        </div>
      }
      <div className={styles.imgContainer}>
        <img src={getImageIndicatorByName(name?.toUpperCase())} alt={name} />
      </div>
    </div>
  );
}
